// Market Data Status API — 화면 15.
// 권위: ARCH_DASHBOARD.md v1.8 §4.15 + §6.2 (REST 계약).

import { apiGet } from './client';

export type FxSource = 'fred' | 'fred_cross' | 'bok' | string;
export type CommoditySource = 'fred' | 'alpha_vantage' | 'stooq' | 'yahoo' | string;

export interface MarketDataFxPair {
  currency_pair: string;
  rate: number | null;
  prev_rate: number | null;
  change_pct: number | null;
  source: FxSource;
  is_stale: boolean;
  fetched_at: string | null;
}

export interface MarketDataCommoditySymbol {
  symbol: string;
  price: number | null;
  prev_price: number | null;
  change_pct: number | null;
  unit: string;
  source: CommoditySource;
  is_stale: boolean;
  fetched_at: string | null;
}

export interface MarketDataStatus {
  /** 호환 필드 — effective_date 와 동일. 신규 코드는 effective_date 사용 권장. */
  as_of_date: string;
  /** 운영자가 요청한 일자 (asOfDate 명시 시 그 값, 미명시 시 today KST). */
  requested_date: string;
  /** 실제 데이터가 존재하는 trading_date (휴장일 fallback 적용 후). */
  effective_date: string;
  fx: {
    pairs: MarketDataFxPair[];
    complete_count: number;
    stale_count: number;
    failed_count: number;
  };
  commodity: {
    symbols: MarketDataCommoditySymbol[];
    complete_count: number;
    stale_count: number;
    failed_count: number;
  };
  last_batch_event: {
    fx_updated_at: string | null;
    commodity_updated_at: string | null;
  };
}

export async function getMarketDataStatus(asOfDate?: string): Promise<MarketDataStatus> {
  const qs = asOfDate ? `?as_of_date=${encodeURIComponent(asOfDate)}` : '';
  return apiGet<MarketDataStatus>(`/api/v1/data/market-data-status${qs}`);
}

export interface MarketDataHistoryEvent {
  event_code: string;
  severity: 'INFO' | 'WARN' | 'ERROR' | string;
  occurred_at: string;
  event_id: string;
  payload_summary?: Record<string, unknown>;
}

export interface MarketDataHistoryDay {
  as_of_date: string;
  events: MarketDataHistoryEvent[];
  fx_source_dist: Record<string, number>;
  commodity_source_dist: Record<string, number>;
}

export async function getMarketDataHistory(windowDays = 7): Promise<MarketDataHistoryDay[]> {
  return apiGet<MarketDataHistoryDay[]>(
    `/api/v1/data/market-data-status/history?window_days=${windowDays}`,
  );
}
